var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_9101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24998 3.53733C-0.836349 7.78183 -1.58548e-05 12.2907 -1.58548e-05 25.9883C-1.58548e-05 37.3633 -1.98468 48.7665 8.40232 51.451C11.6458 52.2852 40.3845 52.2852 43.6237 51.4467C47.9483 50.3308 51.467 46.823 51.948 40.7065C52.0152 39.8528 52.0152 12.139 51.9458 11.268C51.4345 4.75283 47.424 0.997998 42.1395 0.237498C40.9283 0.061998 40.6857 0.00999799 34.4717 -0.000835344C12.4302 0.00999799 7.59848 -0.971502 3.24998 3.53733Z",
    fill: "url(#paint0_linear_1042_9101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9957 6.80173C18.1285 6.80173 10.6579 6.1019 7.80438 13.4252C6.62571 16.4499 6.79688 20.3781 6.79688 26.0027C6.79688 30.9384 6.63871 35.5772 7.80438 38.5781C10.6514 45.9057 18.1827 45.2037 25.9914 45.2037C33.5249 45.2037 41.2924 45.9881 44.1805 38.5781C45.3614 35.5231 45.188 31.6534 45.188 26.0027C45.188 18.5017 45.6019 13.6592 41.964 10.0236C38.2807 6.34023 33.2995 6.80173 25.987 6.80173H25.9957ZM24.2754 10.2619C40.6857 10.2359 42.7744 8.41157 41.6217 33.7551C41.2122 42.7186 34.3872 41.7349 25.9979 41.7349C10.7012 41.7349 10.2614 41.2972 10.2614 25.9941C10.2614 10.5132 11.4747 10.2706 24.2754 10.2576V10.2619ZM36.244 13.4491C34.9722 13.4491 33.9409 14.4804 33.9409 15.7522C33.9409 17.0241 34.9722 18.0554 36.244 18.0554C37.5159 18.0554 38.5472 17.0241 38.5472 15.7522C38.5472 14.4804 37.5159 13.4491 36.244 13.4491ZM25.9957 16.1422C20.5509 16.1422 16.1374 20.5579 16.1374 26.0027C16.1374 31.4476 20.5509 35.8611 25.9957 35.8611C31.4405 35.8611 35.8519 31.4476 35.8519 26.0027C35.8519 20.5579 31.4405 16.1422 25.9957 16.1422ZM25.9957 19.6024C34.4565 19.6024 34.4674 32.4031 25.9957 32.4031C17.537 32.4031 17.524 19.6024 25.9957 19.6024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1042_9101",
    x1: 3.34969,
    y1: 48.6779,
    x2: 51.6782,
    y2: 6.85011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_9101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b3936582ff214cde94040bd454633e6a.svg";
export { ForwardRef as ReactComponent };